import React from 'react'
import avatar1 from  "../../assets/img/xs/avatar1.jpg"

const Schedule = () => {
  return (
    
        <div className="modal-content">
            <div className="modal-header bg-secondary rounded-0">
                <h5 className="modal-title text-light">Schedule</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body custom_scroll">
                <div className="ps-2">
                    <div className="timeline-item ti-primary p-3">
                        <div className="avatar sm rounded-circle no-thumbnail">
                            <i className="fa fa-phone"></i>
                        </div>
                        <div className="timeline-content ms-3">
                            <div>Call Danny at Colby's</div>
                            <small className="text-muted">Today - 11:32am</small>
                        </div>
                    </div>
                    <div className="timeline-item ti-info p-3">
                        <div className="timeline-icon">
                            <img className="avatar sm rounded-circle" src={avatar1} alt="" />
                        </div>
                        <div className="timeline-content ms-3">
                            <div>Meeting with Alice</div>
                            <small className="text-muted">Today - 12:50pm</small>
                        </div>
                    </div>
                    <div className="timeline-item ti-danger p-3">
                        <div className="avatar sm rounded-circle no-thumbnail">
                            <i className="fa fa-comment"></i>
                        </div>
                        <div className="timeline-content ms-3">
                            <div>Answer Annie's message</div>
                            <small className="text-muted">Today - 01:35pm</small>
                        </div>
                    </div>
                    <div className="timeline-item ti-danger p-3">
                        <div className="avatar sm rounded-circle no-thumbnail">
                            <i className="fa fa-phone"></i>
                        </div>
                        <div className="timeline-content ms-3">
                            <div>Send new campaign</div>
                            <small className="text-muted">Today - 02:40pm</small>
                        </div>
                    </div>
                    <div className="timeline-item ti-primary p-3">
                        <div className="avatar sm rounded-circle no-thumbnail">
                            <i className="fa fa-smile-o"></i>
                        </div>
                        <div className="timeline-content ms-3">
                            <div>Project review</div>
                            <small className="text-muted">Today - 03:15pm</small>
                        </div>
                    </div>
                    <div className="timeline-item ti-warning p-3">
                        <div className="avatar sm rounded-circle no-thumbnail">
                            <i className="fa fa-phone"></i>
                        </div>
                        <div className="timeline-content ms-3">
                            <div>Call Trisha Jackson</div>
                            <small className="text-muted">Today - 05:40pm</small>
                        </div>
                    </div>
                    <div className="timeline-item ti-success p-3">
                        <div className="avatar sm rounded-circle no-thumbnail">
                            <i className="fa fa-leaf"></i>
                        </div>
                        <div className="timeline-content ms-3">
                            <div>Write proposal for Don</div>
                            <small className="text-muted">Today - 06:30pm</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
   
  )
}

export default Schedule